import { Box, styled } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers';

export const Hr = styled('hr')({
  width: 'calc(100% + 32px)',
  margin: '0 -16px',
  border: 'none',
  borderBottom: '1px solid #EDEFF2'
});

export const StyledStaticDatePicker = styled(StaticDatePicker)({
  color: 'black',
  '.MuiPickerStaticWrapper-content': {
    backgroundColor: 'white'
  },
  '.MuiDayPicker-slideTransition': {
    minHeight: '220px'
  }
});

export const PostEditorSection = styled(Box)({
  padding: '26px 0px 16px 0px',
  display: 'flex',
  flexDirection: 'column',
  color: '#1C3D64'
});

export const PostEditorWrapper = styled(Box)({
  marginBottom: '16px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
});

export const PostEditorDescription = styled(Box)({
  fontSize: '16px',
  display: 'flex',
  marginRight: 'auto'
});

export const PostEditor = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  marginTop: '16px'
});

export const PostEditorControls = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '16px'
});

export const PostEditorCounter = styled(Box)({
  margin: 'auto',
  color: '#5E6C84'
});

export const ScheduleSection = styled(Box)({
  padding: '16px 0',
  display: 'flex',
  color: '#1C3D64'
});

export const ScheduleTimeBlock = styled(Box)({
  padding: '16px 0 0 32px',
  display: 'flex',
  flexDirection: 'column'
});

export const ScheduleTime = styled(Box)({
  margin: 'auto',
  fontSize: '16px',
  padding: '16px',
  textAlign: 'center',
  span: {
    fontWeight: '500'
  }
});

export const ToolbarSection = styled(Box)({
  padding: '16px 0',
  width: '100%',
  display: 'flex',
  button: {
    marginLeft: '16px'
  }
});
